import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const PaymentCancel = () => (
  <div className="min-h-screen bg-ink flex items-center justify-center px-5" data-testid="payment-cancel-page">
    <div className="max-w-md w-full glass-panel chart-frame border border-line p-10 text-center">
      <XCircle size={34} className="text-slate-500 mx-auto" />
      <h1 className="mt-6 font-display font-bold text-2xl text-slate-50" data-testid="payment-cancel-title">
        Checkout cancelled
      </h1>
      <p className="mt-3 text-sm text-slate-400 leading-relaxed">
        No charge was made. Whenever you're ready, Atlas will be here —
        the zones aren't going anywhere.
      </p>
      <Link to="/" data-testid="cancel-back-home-link"
        className="mt-8 inline-block bg-gold text-ink font-semibold text-sm px-7 py-3.5 rounded-sm hover:bg-gold-bright transition-colors">
        Back to Atlas
      </Link>
    </div>
  </div>
);

export default PaymentCancel;
